const TrustBox = () => {
  return (
    <div className="trustpilot-widget"
         data-locale="en-US"
         data-template-id="54ad5defc6454f065c28af8b"
         data-businessunit-id="5b3cdead266600000141929b"
         data-style-height="240px"
         data-style-width="100%"
         data-stars="3,4,5"
         data-review-languages="en">
      <a href="https://www.trustpilot.com/review/haloflights.co.uk" target="_blank" rel="noopener noreferrer">
        Trustpilot
      </a>
    </div>
  );
};

export default TrustBox;
